import React from "react";
import { Route, Routes } from "react-router-dom";
import App from "./App";
import Login from "./Login";
import Manage from "./Manage";

const RoutesComponent = () => {
  const [token, setToken] = React.useState("");

  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/login" element={<Login setToken={setToken} />} />
      <Route path="/manage" element={<Manage token={token} setToken={setToken} />} />
    </Routes>
  );
};

export default RoutesComponent;
